import TableContainer from "components/Common/TableContainer"
import React, { useMemo } from "react"
import { Badge, Card, CardBody, UncontrolledTooltip } from "reactstrap"

export default function DeliveryChallansTab({ setDeliveryChallanPage }) {
  const isLoading = false
  const data = {
    data: [
      {
        id: 1,
        number: "DC-001",
        date: "2025-01-16",
        status: "Delivered",
        driver: "Mike Johnson",
      },
      {
        id: 2,
        number: "DC-002",
        date: "2025-01-22",
        status: "Pending",
        driver: "Sarah Wilson",
      },
    ],
    pagination: {
      current_page: 1,
      from: 1,
      last_page: 1,
      to: 2,
      total: 2,
    },
  }
  // Delivery Challan Table Columns
  const deliveryChallanColumns = useMemo(
    () => [
      {
        header: "Challan No",
        accessorKey: "number",
      },
      {
        header: "Date",
        accessorKey: "date",
      },
      {
        header: "Driver",
        accessorKey: "driver",
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ row }) => (
          <Badge
            color={row.original.status === "Delivered" ? "success" : "warning"}
          >
            {row.original.status}
          </Badge>
        ),
      },
      {
        header: "Action",
        cell: ({ row }) => (
          <ul className="list-unstyled hstack gap-1 mb-0">
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-info"
                id={`view-dc-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-eye-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`view-dc-tooltip-${row.original.id}`}
                >
                  View
                </UncontrolledTooltip>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-primary"
                id={`download-dc-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-download" />
                <UncontrolledTooltip
                  placement="top"
                  target={`download-dc-tooltip-${row.original.id}`}
                >
                  Download
                </UncontrolledTooltip>
              </button>
            </li>
          </ul>
        ),
      },
    ],
    []
  )
  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Delivery Challans</h5>
          <Badge color="primary" pill className="px-3 py-2">
            {data.pagination.total} records
          </Badge>
        </div>

        <TableContainer
          columns={deliveryChallanColumns}
          data={data.data}
          isPagination={true}
          paginationInfo={data.pagination}
          onPageChange={setDeliveryChallanPage}
          loading={isLoading}
        />
      </CardBody>
    </Card>
  )
}
